export default "__VITE_ASSET__DWbvQL2z__"